module.exports = __webpack_public_path__ + "static/media/ApercuPro-Black.de32d2f7.woff2";